import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Label,
  Input,
  Spinner,
} from "reactstrap";

import usePersistStoreData from "../../Components/Hooks/usePersistStoreData";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  supportRaiseQueryThunk,
  support_getCategoriesThunk,
} from "../../slices/thunks";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { showToast } from "../../Components/ToastNotification";

const Support = () => {
  // document.title = "Dashboard | B.N. Rathi";

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();
  const token = userData?.token;

  const { supportCategoriesData, supportCategoriesLoading } = useSelector(
    (state) => state.Support_Get_Categories
  );

  const { supportQueryLoading } = useSelector(
    (state) => state.Support_Raise_Query
  );

  const initialValues = {
    category: "",
    description: "",
  };

  const validationSchema = Yup.object().shape({
    category: Yup.string().required("Category is required!"),
    description: Yup.string()
      .min(10, "Description must be at least 10 characters!")
      .max(150, "Description cannot exceed 150 characters!")
      .required("Description is required!"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    // Create a new FormData instance for API submission
    const formData = new FormData();
    formData.append("category", values.category);
    formData.append("description", values.description);

    try {
      await dispatch(
        supportRaiseQueryThunk({ body: formData, token })
      ).unwrap();
      showToast("Request submitted successfully", "success");
      resetForm();
    } catch (error) {
      // Log and show error toast if something goes wrong
      console.error("Error submitting support query:", error);
      showToast(
        error?.message || "Something went wrong, please try again",
        "error"
      );
    }
  };

  useEffect(() => {
    dispatch(support_getCategoriesThunk({ token }));
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Card className="mb-0">
            <CardHeader
              style={{
                backgroundColor: "#0F528D",
              }}
            >
              <div className="m-0 p-0 d-flex align-items-center justify-content-between">
                <h3
                  className="m-0"
                  style={{
                    color: "#fff",
                  }}
                >
                  Support
                </h3>
              </div>
            </CardHeader>
          
            <CardBody>
            <div className="">
          <h4 className="text-dark">
          Please feel free to contact us in case of any queries. Our support team will get back to you within 24–48 hours.


          </h4>
        </div>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({
                  errors,
                  touched,
                  setFieldValue,
                  isSubmitting,
                  handleChange,
                  handleBlur,
                  values,
                  handleSubmit,
                  resetForm,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row className="mb-1">
                      <Col>
                        <div>
                          <Label for="category" className="col-form-label pb-2">
                            Select Category *
                          </Label>
                          <Input
                            className="form-control"
                            type="select"
                            name="category"
                            id="category"
                            value={values.category}
                            onChange={handleChange} // Ensure Formik updates its state
                            onBlur={handleBlur}
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            {supportCategoriesData &&
                              Object.entries(supportCategoriesData).map(
                                ([key, label]) => (
                                  <option key={key} value={key}>
                                    {label}
                                  </option>
                                )
                              )}
                          </Input>
                          <ErrorMessage
                            name="category"
                            component="div"
                            className="text-danger fs-14"
                          />
                        </div>
                      </Col>
                    </Row>

                    {/* Description Field */}
                    <div className="mb-1">
                      <Label for="description" className="col-form-label pb-2">
                        Description *
                      </Label>
                      <Field
                        as="textarea"
                        className="form-control"
                        type="textarea"
                        name="description"
                        id="description"
                        placeholder="Enter description"
                        rows={5}
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="text-danger fs-14"
                      />
                    </div>

                    {/* Submit Button */}
                    <div className="text-center mt-3">
                      <Button
                        type="submit"
                        color="success"
                        disabled={supportQueryLoading}
                        style={{ minWidth: "120px" }}
                      >
                        {supportQueryLoading ? <Spinner size="sm" /> : "Submit"}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </Container>
        
      </div>
    </React.Fragment>
  );
};

export default Support;
